import { render, staticRenderFns } from "./applygdtdouyingYy.vue?vue&type=template&id=3bd5b4f2&scoped=true&"
import script from "./applygdtdouyingYy.vue?vue&type=script&lang=js&"
export * from "./applygdtdouyingYy.vue?vue&type=script&lang=js&"
import style0 from "./applygdtdouyingYy.vue?vue&type=style&index=0&id=3bd5b4f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5b4f2",
  null
  
)

export default component.exports